import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { CounterBadge, IconAction, LocalizedText, ModalContext, PermissionTooltip } from 'labguard-cdk'
import { AcknowledgeAlarmIcon } from 'src/components/common/icons'
import { useChannelPermission } from 'src/hooks'
import ChannelAlarmModal from '../ChannelAlarmModal'
import styles from './AcknowledgeOrComment.scss'

const AcknowledgeOrComment = ({ alarm }) => {
  const { createModalOpener } = ModalContext.use()
  const onAck = createModalOpener(<ChannelAlarmModal alarmId={alarm.id} />)
  const hasPermission = useChannelPermission(alarm.channel.id,'update.acknowledge')

  const btnTooltip = alarm.toBeAcknowledged ? (
    <LocalizedText id="WEB_ACKNOWLEDGE_AN_ALARM" />
  ) : (
    <LocalizedText id="WEB_ADD_COMMENT" />
  )
  const badgeClass = classnames({ [styles.hidden]: alarm.toBeAcknowledged })
  const btnIcon = alarm.toBeAcknowledged ? AcknowledgeAlarmIcon : 'sticky-note'
  return (
    <CounterBadge className={badgeClass} count={alarm.nbComments} truncate>
      <PermissionTooltip allowed={hasPermission}>
        <IconAction icon={btnIcon} size="lg" tooltip={btnTooltip} onClick={onAck} disabled={!hasPermission} />
      </PermissionTooltip>
    </CounterBadge>
  )
}

AcknowledgeOrComment.propTypes = {
  alarm: PropTypes.shape({
    id: PropTypes.string,
    channel: PropTypes.object,
    toBeAcknowledged: PropTypes.bool,
    nbComments: PropTypes.number,
  }),
}

export default AcknowledgeOrComment
